import { CSSProperties, ReactNode } from 'react'

import { Paper, Stack } from '@mui/material'

import { EditTimeWindows } from './components/EditTimeWindows'
import { FormHeader } from './components/FormHeader'
import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

type Props = {
  label: string
  testId?: string
  value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]
  disabled: boolean
  error: boolean
  helperText: ReactNode
  validate: (force?: boolean) => void
  onChange: (value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]) => void
}

const MainPaperStyle: CSSProperties = {
  background: '#F3F5F7',
  padding: '16px 8px',
}

export function TimeWindows(props: Props) {
  const {
    label,
    testId = 'orderStep-timeWindows',
    value,
    disabled,
    error,
    helperText,
    validate,
    onChange,
  } = props

  const actions = useActions(value, onChange)
  const texts = useTexts()

  const addTimeWindowDisabled = value.length === 2

  return (
    <Stack data-testid={testId} data-trackid={testId} gap={2}>
      <FormHeader
        label={label}
        action={{
          label: texts.addTimeWindowsLabel,
          tooltip: texts.addTimeWindowTooltip,
          disabledTooltip: texts.addTimeWindowDisabledTooltip,
          onClick: actions.onAddTimeWindow,
          disabled: addTimeWindowDisabled,
        }}
        testId={`${testId}-section-header`}
      />

      {value.length > 0 && (
        <Paper elevation={0} sx={MainPaperStyle}>
          <EditTimeWindows
            onUpdateTimeWindow={actions.onUpdateTimeWindow}
            onRemoveTimeWindow={actions.onRemoveTimeWindow}
            validate={validate}
            value={value}
            disabled={disabled}
            error={error}
            helperText={helperText}
          />
        </Paper>
      )}
    </Stack>
  )
}
